import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExcelUploadResponse } from 'src/app/models/ExcelUploadResponse';
import { IomService } from 'src/app/services/iom.service';
import { MessageService } from 'src/app/services/message.service';
import { SessionService } from 'src/app/services/session.service';
import { timeout } from 'rxjs/operators';
import { Router } from '@angular/router';
declare var $: any;
declare var bootbox: any;

@Component({
  selector: 'app-attribute-mapping',
  templateUrl: './attribute-mapping.component.html',
  styleUrls: ['./attribute-mapping.component.css']
})
export class AttributeMappingComponent implements OnInit {

  MappingAttributeData: any;
  WorkSheetList: any;
  FilteredStandardField: any;
  TotalColumnHeaders: any;
  // model
  TicketIDModel: string = "";
  TicketOpenDateModel: string = "";
  TicketShortDescriptionModel: string = "";
  EffortModel: string = "";
  AssignedGroupModel: string = "";
  ChannelSourceModel: string = "";
  TicketCloseDateModel: string = "";
  StatusModel: string = "";
  PriorityModel: string = "";
  ResolutionSLAModel: string = "";
  ResolutionDescriptionModel: string = "";
  LongDescriptionModel: string = "";
  TowerApplicationNameModel: string = "";
  CustomfieldModel1: string = "";
  CustomfieldModel2: string = "";
  CustomfieldModel3: string = "";
  CustomfieldModel4: string = "";
  CustomfieldModel5: string = "";
  CustomfieldModel6: string = "";
  CustomfieldModel7: string = "";
  CustomfieldModel8: string = "";
  CustomfieldModel9: string = "";
  CustomfieldModel10: string = "";
  CustomfieldModel11: string = "";
  CustomfieldModel12: string = "";
  isCustom1: boolean;
  isCustom2: boolean;
  isCustom3: boolean;
  isCustom4: boolean;
  isCustom5: boolean;
  isCustom6: boolean;
  isCustom7: boolean;
  isCustom8: boolean;
  isCustom9: boolean;
  isCustom10: boolean;
  isCustom11: boolean;
  isCustom12: boolean;
  CustomFiledCount: number = 0;
  customfield = 0;
  actualCustomField = 0;
  displayCustCount = 0;
  // model end
  ProposalId: string;
  CreateDDInput: ExcelUploadResponse = new ExcelUploadResponse();
  HistoryCreateDDInput: ExcelUploadResponse = new ExcelUploadResponse();
  HistoricalDomainMapping: { MappingFiled: string, MappingValue: string, Domain: string }[];
  categorisedBy: { Key: string, Value: string[] }[]; // = [{"Key":"Assigned_Group","Value":["Assigned Group 1","Assigned Group 6","Assigned Group 7","Assigned Group 8","Assigned Group 9","Assigned Group 10","Assigned Group 11","Assigned Group 12","Assigned Group 13","Assigned Group 14","Assigned Group 15","Assigned Group 16"]},{"Key":"Ticket Source","Value":["Email","Phone","Self-service","Auto","Chat","Walk-in"]},{"Key":"Severity","Value":["4","3","2"]},{"Key":"SLA","Value":["Met","Breached"]},{"Key":"Business_Section","Value":["Business Section1","Business Section2","s","Business Section4","Business Section3"]}]
  ClassifiedBy: { Key: string, Value: string[] }[]; // = [{"Key":"Assigned_Group","Value":["Assigned Group 1","Assigned Group 6","Assigned Group 7","Assigned Group 8","Assigned Group 9","Assigned Group 10","Assigned Group 11","Assigned Group 12","Assigned Group 13","Assigned Group 14","Assigned Group 15","Assigned Group 16"]},{"Key":"Ticket Source","Value":["Email","Phone","Self-service","Auto","Chat","Walk-in"]},{"Key":"Severity","Value":["4","3","2"]},{"Key":"SLA","Value":["Met","Breached"]},{"Key":"Business_Section","Value":["Business Section1","Business Section2","s","Business Section4","Business Section3"]}]
  ExcelMappingField = [];
  isResponse: boolean;
  selectedSheet: string = "";
  enableReset: boolean;
  constructor(private spinner: NgxSpinnerService, private iomservice: IomService, private messageService: MessageService, private SessionService: SessionService, private router: Router) { }

  ngOnInit(): void {
    if (this.SessionService.getSessionStorageItem('FileName') == null || this.SessionService.getSessionStorageItem('FileName') == "") {
      bootbox.alert('Please upload the ticket data..!');
      let element: HTMLElement = document.getElementById('uploadExceltemp') as HTMLElement;
      element.click();
    }
    //this.ProposalId = parseInt(this.SessionService.getSessionStorageItem("selectedProposalId"));
    this.enableReset = false;
    this.ProposalId = this.SessionService.getDeliveryConstructUId();
    this.getSheetName();
    //this.getMappingAttribute();
    //var flags = {};
    // this.WorkSheetList = this.MappingAttributeData.filter(function (entry) {
    //   if (flags[entry.SheetName]) {
    //     return false;
    //   }
    //   flags[entry.SheetName] = true;
    //   return true;
    // });
    // this.hideCustomFields();
    // this.addCustomField();

  }
  getSheetName() {
    let frmData = new FormData();
    frmData.append("fileName", this.SessionService.getSessionStorageItem('FileName'));
    this.spinner.show();
    this.iomservice.GetSheetName<any>(frmData).subscribe(data => {
      //this.spinner.hide();
      this.WorkSheetList = data;
      this.getMappingAttribute(this.WorkSheetList[0]);
      //this.WorkSheetList = ["2. Ticket Raw data", "sheet1"];
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error Occured !");
      });
  }
  getStandardField(event: any) {
    let SheeetName = event.target.value;
    this.selectedSheet = SheeetName;
    this.getMappingAttribute(SheeetName);
  }
  getMappingAttribute(SheeetName) {
    this.selectedSheet = SheeetName;
    this.MappingAttributeData = [];
    this.FilteredStandardField = [];
    this.spinner.show();
    let frmData = new FormData();
    frmData.append("fileName", this.SessionService.getSessionStorageItem('FileName'));
    
        this.iomservice.ReadExcelColumns<any>(SheeetName, frmData).subscribe(data => {          
          if (data) {
            this.spinner.hide();
            this.MappingAttributeData = data;
            this.TotalColumnHeaders = data;
            this.FilteredStandardField = this.MappingAttributeData.filter(x => x.SheetName == SheeetName);
            this.autoPopulateField();
            this.isResponse = true;
            this.addCustomField();
          }
          else {
            this.spinner.hide();
            bootbox.alert("Error Occured !");
            this.isResponse = false;
          }
        },
          (err: HttpErrorResponse) => {
            this.spinner.hide();
            bootbox.alert("Error Occured !");
          });
        
  }
  autoPopulateField() {
    for (var i = 0; i < this.FilteredStandardField.length; i++) {
      if (this.FilteredStandardField[i].ActualField == "TicketID" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.TicketIDModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "TicketOpenDate" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.TicketOpenDateModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "TicketShortDescription" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.TicketShortDescriptionModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "Effort" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.EffortModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "AssignedGroup" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.AssignedGroupModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "Channel/Source" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.ChannelSourceModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "TicketClosedDate" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.TicketCloseDateModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "Status" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.StatusModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "Priority" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.PriorityModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "ResolutionSLA" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.ResolutionSLAModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "ResolutionDescription" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.ResolutionDescriptionModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "LongDescription" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.LongDescriptionModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "Tower/ApplicationName" && this.FilteredStandardField[i].PrePopulatedField != "") {
        this.TowerApplicationNameModel = this.FilteredStandardField[i].PrePopulatedField;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField1" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel1 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom1 = true;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField2" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel2 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom2 = true;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField3" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel3 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom3 = true;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField4" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel4 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom4 = true;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField5" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel5 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom5 = true;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField6" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel6 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom6 = true;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField7" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel7 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom7 = true;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField8" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel8 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom8 = true;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField9" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel9 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom9 = true;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField10" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel10 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom10 = true;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField11" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel11 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom11 = true;
      }
      if (this.FilteredStandardField[i].ActualField == "CustomField12" && this.FilteredStandardField[i].PrePopulatedField != "") {
        if(this.FilteredStandardField[i].PrePopulatedField == null){
          this.FilteredStandardField[i].PrePopulatedField = "";
        }
        this.CustomfieldModel12 = this.FilteredStandardField[i].PrePopulatedField;
        this.actualCustomField++;
        this.isCustom12 = true;
      }
    }
  }
  getDataType(actualColumn) {
    var type;
    type = this.FilteredStandardField.filter(x => x.ActualField == actualColumn)[0];
    if (type != null && type != undefined) {
      return type.DataType;
    }
    else {
      return "";
    }
  }
  apply() {
    if (this.validateDD()) {
      // if (!this.validateOptions('apply')) {
      //   return false;
      // }
      this.ExcelMappingField = [];
      var selectEmptyVal;
      if (this.TicketIDModel != "") {
        selectEmptyVal = $('#TicketIDModel').val();
        if (selectEmptyVal == "") {
          this.TicketIDModel = selectEmptyVal;
          bootbox.alert("Please select mapping for Ticket No.")
          return false;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.TicketIDModel, "TicketID", 0, this.getDataType("TicketID")));
      }
      if (this.TicketOpenDateModel != "") {
        selectEmptyVal = $('#TicketOpenDateModel').val();
        if (selectEmptyVal == "") {
          this.TicketOpenDateModel = selectEmptyVal;
          bootbox.alert("Please select mapping for Ticket Reported Date.")
          return false;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.TicketOpenDateModel, "TicketOpenDate", 0, this.getDataType("TicketOpenDate")));
      }
      if (this.TicketShortDescriptionModel != "") {
        selectEmptyVal = $('#TicketShortDescriptionModel').val();
        if (selectEmptyVal == "") {
          this.TicketShortDescriptionModel = selectEmptyVal;
          bootbox.alert("Please select mapping for Ticket Short Description.")
          return false;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.TicketShortDescriptionModel, "TicketShortDescription", 0, this.getDataType("TicketShortDescription")));
      }

      if (this.EffortModel != "") {
        selectEmptyVal = $('#EffortModel').val();
        if (selectEmptyVal == "") {
          this.EffortModel = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.EffortModel, "Effort", 0, this.getDataType("Effort")));
      }
      if (this.AssignedGroupModel != "") {
        selectEmptyVal = $('#AssignedGroupModel').val();
        if (selectEmptyVal == "") {
          this.AssignedGroupModel = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.AssignedGroupModel, "AssignedGroup", 0, this.getDataType("AssignedGroup")));
      }
      if (this.ChannelSourceModel != "") {
        selectEmptyVal = $('#ChannelSourceModel').val();
        if (selectEmptyVal == "") {
          this.ChannelSourceModel = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.ChannelSourceModel, "Channel/Source", 0, this.getDataType("Channel/Source")));
      }
      if (this.TicketCloseDateModel != "") {
        selectEmptyVal = $('#TicketCloseDateModel').val();
        if (selectEmptyVal == "") {
          this.TicketCloseDateModel = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.TicketCloseDateModel, "TicketClosedDate", 0, this.getDataType("TicketClosedDate")));
      }
      if (this.StatusModel != "") {
        selectEmptyVal = $('#StatusModel').val();
        if (selectEmptyVal == "") {
          this.StatusModel = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.StatusModel, "Status", 0, this.getDataType("Status")));
      }
      if (this.PriorityModel != "") {
        selectEmptyVal = $('#priorityModelId').val();
        if (selectEmptyVal == "") {
          this.PriorityModel = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.PriorityModel, "Priority", 0, this.getDataType("Priority")));
      }
      if (this.ResolutionSLAModel != "") {
        selectEmptyVal = $('#ResolutionSLAModel').val();
        if (selectEmptyVal == "") {
          this.ResolutionSLAModel = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.ResolutionSLAModel, "ResolutionSLA", 0, this.getDataType("ResolutionSLA")));
      }
      if (this.ResolutionDescriptionModel != "") {
        selectEmptyVal = $('#ResolutionDescriptionModel').val();
        if (selectEmptyVal == "") {
          this.ResolutionDescriptionModel = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.ResolutionDescriptionModel, "ResolutionDescription", 0, this.getDataType("ResolutionDescription")));
      }
      if (this.LongDescriptionModel != "") {
        selectEmptyVal = $('#LongDescriptionModel').val();
        if (selectEmptyVal == "") {
          this.LongDescriptionModel = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.LongDescriptionModel, "LongDescription", 0, this.getDataType("LongDescription")));
      }
      if (this.TowerApplicationNameModel != "") {
        selectEmptyVal = $('#TowerApplicationNameModel').val();
        if (selectEmptyVal == "") {
          this.TowerApplicationNameModel = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.TowerApplicationNameModel, "Tower/ApplicationName", 0, this.getDataType("Tower/ApplicationName")));
      }
      // custom field
      if (this.CustomfieldModel1 != "") {
        selectEmptyVal = $('#CustomfieldModelId1').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel1 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel1, "CustomField 1", 1, this.getDataType("CustomField1")));
      }
      if (this.CustomfieldModel2 != "") {
        selectEmptyVal = $('#CustomfieldModelId2').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel2 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel2, "CustomField 2", 1, this.getDataType("CustomField2")));
      }
      if (this.CustomfieldModel3 != "") {
        selectEmptyVal = $('#CustomfieldModelId3').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel3 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel3, "CustomField 3", 1, this.getDataType("CustomField3")));
      }
      if (this.CustomfieldModel4 != "") {
        selectEmptyVal = $('#CustomfieldModelId4').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel4 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel4, "CustomField 4", 1, this.getDataType("CustomField4")));
      }
      if (this.CustomfieldModel5 != "") {
        selectEmptyVal = $('#CustomfieldModelId5').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel5 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel5, "CustomField 5", 1, this.getDataType("CustomField5")));
      }
      if (this.CustomfieldModel6 != "") {
        selectEmptyVal = $('#CustomfieldModelId6').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel6 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel6, "CustomField 6", 1, this.getDataType("CustomField6")));
      }
      if (this.CustomfieldModel7 != "") {
        selectEmptyVal = $('#CustomfieldModelId7').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel7 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel7, "CustomField 7", 1, this.getDataType("CustomField7")));
      }
      if (this.CustomfieldModel8 != "") {
        selectEmptyVal = $('#CustomfieldModelId8').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel8 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel8, "CustomField 8", 1, this.getDataType("CustomField8")));
      }
      if (this.CustomfieldModel9 != "") {
        selectEmptyVal = $('#CustomfieldModelId9').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel9 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel9, "CustomField 9", 1, this.getDataType("CustomField9")));
      }
      if (this.CustomfieldModel10 != "") {
        selectEmptyVal = $('#CustomfieldModelId10').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel10 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel10, "CustomField 10", 1, this.getDataType("CustomField10")));
      }
      if (this.CustomfieldModel11 != "") {
        selectEmptyVal = $('#CustomfieldModelId11').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel11 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel11, "CustomField 11", 1, this.getDataType("CustomField11")));
      }
      if (this.CustomfieldModel12 != "") {
        selectEmptyVal = $('#CustomfieldModelId12').val();
        if (selectEmptyVal == "") {
          this.CustomfieldModel12 = selectEmptyVal;
        }
        this.ExcelMappingField.push(this.getMappingObject(this.CustomfieldModel12, "CustomField 12", 1, this.getDataType("CustomField12")));
      }
      let frmData = new FormData();
      frmData.append("ProposalId", this.ProposalId.toString());
      frmData.append("UserType", this.SessionService.getSessionStorageItem('ExelUserType'));
      frmData.append("fileName", this.SessionService.getSessionStorageItem('FileName'));
      frmData.append("UserId", this.SessionService.getUserName());
      frmData.append("excelMappingField", JSON.stringify(this.ExcelMappingField));
      let that = this;
      bootbox.confirm({
        message: 'These attributes will be used for Ticket Classification. <br/> Are you sure to continue ?',
        buttons: {
          confirm: {
            label: 'Yes',
            className: 'btn-primary'
          },
          cancel: {
            label: 'No',
            className: 'btn-secondary'
          }
        },
        callback: function (result) {
          if (result) //'Yes' selection
          {
            that.validateExcel(frmData);
          }
          else //'No' selection
          {
            //TODO:
          }
        }
      });
    }
  }
  validateExcel(frmData) {
    this.spinner.show();
    this.iomservice.UplodExcelFile(frmData).pipe(timeout(2400000)).subscribe((data: any) => {
      this.spinner.hide();
      if (data) {
        if (data.Message && data.Message == "Success") {
          //this.btnText = "Next";
          //this.displayMappingDiv = true;
          //this.CreateDDInput.BAUploadedData = data.BAUploadData;
          this.CreateDDInput.DisplayLongDesc = data.DisplayLongDesc;
          this.CreateDDInput.DisplayResolutionDesc = data.DisplayResolutionDesc;
          this.CreateDDInput.ExcelMappingFields = data.ExcelMappingFields;
          this.CreateDDInput.MinTicketDate = data.MinTicketDate;
          this.CreateDDInput.MaxTicketDate = data.MaxTicketDate;
          let ticketTypes_io = [];
          if(data.TicketTypes != null){
          this.CreateDDInput.TicketTypes_IO = data.TicketTypes.slice(0, 2);
          this.CreateDDInput.TicketTypes_AO = data.TicketTypes.sort((a, b) => (a.TicketType > b.TicketType) ? 1 : -1);
          let ticketTypes_io = [];
          if (data.TicketTypes != null) {
            let ticketTypes = data.TicketTypes.sort((a, b) => (a.TicketType > b.TicketType) ? 1 : -1);
            ticketTypes.forEach(function (key, index) {
              if (index == 0 || index == 2) {
                ticketTypes_io.push(key);
              }
            });
          }
        }
        else{
          this.CreateDDInput.TicketTypes_AO = null;
        }
          // this.CreateDDInput.TicketTypes_IO = ticketTypes_io;
          // this.CreateDDInput.TicketTypes_IO = data.TicketTypes.slice(0, 2);
          // this.CreateDDInput.TicketTypes_IO = data.TicketTypes.sort((a,b) => (a.TicketType > b.TicketType) ? 1 : -1) .slice(0, 2);
          this.CreateDDInput.MandatoryColumns = data.MandatoryColumns;
          this.CreateDDInput.ActualColumns = data.ActualColumns;
          this.CreateDDInput.WordCloudFilterOptions = data.WordCloudFilterOptions;
          this.categorisedBy = data.CategorisedBy ? data.CategorisedBy : [];
          this.ClassifiedBy = data.ClassifiedBy ? data.ClassifiedBy : [];
          this.HistoricalDomainMapping = data.HistoricalDomainMapping ? data.HistoricalDomainMapping : [];
          //this.categorisedBy.map(x => x.Key = (x.Key == x.Key.toUpperCase() ? x.Key.trim().replace(/[^a-zA-Z0-9]/g, ' ') : this.toPascalCase(x.Key).replace(/([A-Z])/g, ' $1').trim())); //.match(/^[A-Z]*$/)
          var a = this.categorisedBy.map(x => x.Key)
          for (var i = 0; i < a.length; i++) {
            var b = a[i];
            if ((/[a-zA-Z]/.test(b)) == true) {
              this.categorisedBy.map(x => x.Key = x.Key.replace(/[^a-zA-Z0-9]/g, ' '));
            }
          }
          
          var catBy = this.ClassifiedBy.map(x => x.Key)
          for (var i = 0; i < catBy.length; i++) {
            var b = catBy[i];
            if ((/[a-zA-Z]/.test(b)) == true) {
              this.ClassifiedBy.map(x => x.Key = x.Key.replace(/[^a-zA-Z0-9]/g, ' '));
            }
          }
          
          this.CreateDDInput.CategorisedByDD = this.categorisedBy;
          this.CreateDDInput.HistoricalDomainMapping = this.HistoricalDomainMapping;
          this.CreateDDInput.SheetName = this.selectedSheet;
          this.CreateDDInput.fileName = this.SessionService.getSessionStorageItem('FileName');
          this.CreateDDInput.CategorisedBy = this.categorisedBy.map(x => x.Key).map(name => ({ name }));
          this.CreateDDInput.ClassifiedBy = this.ClassifiedBy.map(x => x.Key).map(name => ({ name }));
          this.SessionService.setSessionStorageItem("CreateDDInput", JSON.stringify(this.CreateDDInput));
          this.messageService.updateBAUploadedData(data.BAUploadData);
          this.messageService.updateNavigateToCreateDDTab(true);
        }
        else
          bootbox.alert(data.Message);
      }
      else {
        bootbox.alert("Error occured in fileuplod");
        //this.deleteFile(true);
      }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        if (err.message != "Timeout has occurred") {
          bootbox.alert("Error occured in fileuplod");
        }
      }
    );

  }
  getMappingObject(model, actual, IsCustom, dataType) {
    let obj = {
      "ActualField": actual,
      "MappingField": model,
      "IsCustomField": IsCustom,
      "SheetName": this.selectedSheet,
      "DataType": dataType
    }
    return obj;
  }
  validateDD() {
    if (this.selectedSheet == "") {
      bootbox.alert("Please select Worksheet.")
      return false;
    }
    if (this.TicketIDModel == "") {
      bootbox.alert("Please select mapping for Ticket No.")
      return false;
    }
    if (this.TicketOpenDateModel == "") {
      bootbox.alert("Please select mapping for Ticket Reported Date.")
      return false;
    }
    if (this.TicketShortDescriptionModel == "") {
      bootbox.alert("Please select mapping for Ticket Short Description.")
      return false;
    }
    return true;
  }
  addCustomField() {
    if (this.TotalColumnHeaders.filter(x => x.Flag == 0).length > 0) {
      this.customfield = this.TotalColumnHeaders.filter(x => x.Flag == 0).length;
      if (this.customfield > 0) {
        for (var i = 1; i <= this.customfield; i++) {
          $("#CustomfieldModel" + i).show();
        }
        $("#addCustomfield").css({ 'cursor': 'not-allowed', 'opacity': 0.6 });
        $('#addCustomfield').css({ 'pointer-events': 'none' });
      }
      else {
        bootbox.alert('Custom field is not present.');
        return false;
      }
    }
    else {
      var nonpopulatedfields = 1;
      this.TotalColumnHeaders.filter(x => x.SheetName == this.selectedSheet).forEach(element => {
        if (element.PrePopulatedField == "" || element.PrePopulatedField == null) {
          $("#CustomfieldModel" + nonpopulatedfields).show();
        }
        nonpopulatedfields++;
      });
    }
    this.displayCustCount = this.actualCustomField;
  }

  reset() {
    this.displayCustCount = 0;
    this.setDefault();
    // this.hideCustomFields();
    $("#addCustomfield").css({ 'cursor': 'pointer', 'opacity': 1 });
    $('#addCustomfield').css({ 'pointer-events': 'auto' });
  }
  cancel() {
    this.displayCustCount = 0;
    this.SessionService.removeSessionValue('CreateDDInput');
    this.SessionService.removeSessionValue('ExelUserType');
    this.SessionService.removeSessionValue('FileName');
    this.router.navigate(['deepdive']);
  }
  // hideCustomFields() {
  //   $("#CustomfieldModel1").hide();
  //   $("#CustomfieldModel2").hide();
  //   $("#CustomfieldModel3").hide();
  //   $("#CustomfieldModel4").hide();
  //   $("#CustomfieldModel5").hide();
  //   $("#CustomfieldModel6").hide();
  //   $("#CustomfieldModel7").hide();
  //   $("#CustomfieldModel8").hide();
  //   $("#CustomfieldModel9").hide();
  //   $("#CustomfieldModel10").hide();
  //   $("#CustomfieldModel11").hide();
  //   $("#CustomfieldModel12").hide();
  // }
  setDefault() {
    this.TicketIDModel = "";
    this.TicketOpenDateModel = "";
    this.TicketShortDescriptionModel = "";
    this.EffortModel = "";
    this.AssignedGroupModel = "";
    this.ChannelSourceModel = "";
    this.TicketCloseDateModel = "";
    this.StatusModel = "";
    this.PriorityModel = "";
    this.ResolutionSLAModel = "";
    this.ResolutionDescriptionModel = "";
    this.LongDescriptionModel = "";
    this.TowerApplicationNameModel = "";
    this.CustomfieldModel1 = "";
    this.CustomfieldModel2 = "";
    this.CustomfieldModel3 = "";
    this.CustomfieldModel4 = "";
    this.CustomfieldModel5 = "";
    this.CustomfieldModel6 = "";
    this.CustomfieldModel7 = "";
    this.CustomfieldModel8 = "";
    this.CustomfieldModel9 = "";
    this.CustomfieldModel10 = "";
    this.CustomfieldModel11 = "";
    this.CustomfieldModel12 = "";
    this.CustomFiledCount = 0;
    this.autoPopulateField();

  }

  validateOptions(event: any) {
    if (event != 'apply') {
      this.enableReset = true
      let curValue = event.target.value;
      var currentValues = $(".map-option option:selected").map(function () {
        if ($(this).val() != '')
          return $(this).val();
      }).get();
      //var counts = {};
      //currentValues.forEach(function (x) { counts[x] = (counts[x] || 0) + 1; });
      var duplocateValues = this.findDuplicates(currentValues);
      if (duplocateValues != null && duplocateValues.length > 0) {
        event.target.value = "";
        bootbox.alert("<b>" + curValue + "</b>" + " already mapped in standard/custom attributes, please choose another one.");
        return false;
      }
    }
    else {
      var currentValues = $(".map-option option:selected").map(function () {
        if ($(this).val() != '')
          return $(this).val();
      }).get();
      var duplocateValues = this.findDuplicates(currentValues);
      if (duplocateValues != null && duplocateValues.length > 0) {
        bootbox.alert("Duplicate attribute mapping exist, please choose another attribute.");
        return false;
      }
      else {
        return true;
      }
    }
  }
  findDuplicates = (arr) => {
    let sorted_arr = arr.slice().sort(); // You can define the comparing function here. 

    let results = [];
    for (let i = 0; i < sorted_arr.length - 1; i++) {
      if (sorted_arr[i + 1] == sorted_arr[i]) {
        results.push(sorted_arr[i]);
      }
    }
    return results;
  }
  CancelTicketUpload() {
    this.iomservice.DeleteExcelFile(this.SessionService.getSessionStorageItem('FileName'));
    setTimeout(() => {
      this.router.navigate(['deepdive'], { queryParams: { 'E2EUId': this.SessionService.getE2EUId(), 'CMSUId': this.SessionService.getCMSUId(), 'WSUId': this.SessionService.getWSUId() } });
    }, 100);
  }
}
